import { useCallback, useEffect, useMemo, useState } from 'react'
import NoData from '../../assets/No-Search-Result.png'
import { ACTIONS } from '../../constants/actions'
import { adminEventColumns } from '../../constants/data_columns/events'
import { useEvent } from '../../contexts/event-context'
import HrmLoader from '../components/hrm_loader'
import { HRMTable } from '../components/hrm_table'
import DeleteModal from '../modals/delete_model'
import ViewModal from '../modals/View_modal'

const Events = () => {
  const [eventData, setEventData] = useState([])
  const [selectedId, setSelectedId] = useState(null)
  const [isDeleteFormVisible, setDeleteFormVisible] = useState(false)
  const [selectedViewId, setSelectedViewId] = useState(null)
  const [isViewFormVisible, setIsViewFormVisible] = useState(false)
  const { onLoadEvent, events, eventLoader, onDeleteEvent } = useEvent()
  useEffect(() => {
    onLoadEvent()
  }, [onLoadEvent])

  useEffect(() => {

    if (events?.length > 0) {
      setEventData(
        events.map(item => {
          return {
            id: item.id,
            name: item.name,
            description: item.description,
            email: item.email,
            date: item.date,
            start_time: item.start_time,
            end_time: item.end_time,
            company_name: item.company_name
          }
        })
      )
    }
  }, [events])

  const handleDelete = async () => {
    if (!selectedId) return
    const response = await onDeleteEvent(selectedId)

    onLoadEvent()
    try {
    } catch (error) {
    } finally {
      setDeleteFormVisible(false)
      setSelectedId(null)
    }
  }

  const handleView = async row => {
    if (!row) return

    try {
      setSelectedViewId(row)
      setIsViewFormVisible(true) // Open the modal
    } catch (error) {
      console.error('Failed to fetch contact details:', error)
    }
  }

  const onSelectAction = useCallback(async (row, value) => {
    if (ACTIONS.DELETE === value) {
      setSelectedId(row.id)
      setDeleteFormVisible(true)
    } else if (ACTIONS.VIEW === value) {
      // Handle View action
      setSelectedViewId(row)
      setIsViewFormVisible(true)
      handleView(row)
    } else {
    }
  }, [])

  const columns = useMemo(() => {
    return adminEventColumns({ onSelectAction })
  }, [onSelectAction])

  return (
    <div>
      <div className='col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6'>
        <h5 className='mb-2'>Events</h5>
      </div>
      <div className='card'>
        <div className='card-body'>
          {eventLoader ? (
            <HrmLoader />
          ) : eventData?.length > 0 ? (
            <>
              <HRMTable data={eventData} columns={columns} />
              {isDeleteFormVisible && (
                <DeleteModal
                  isVisible={isDeleteFormVisible}
                  onClose={() => {
                    setDeleteFormVisible(false)
                    setSelectedId(null)
                  }}
                  onConfirm={handleDelete}
                  title='Delete Event'
                  description='Are you sure you want to delete this Event?'
                />
              )}
              <ViewModal
                isVisible={isViewFormVisible}
                onClose={() => {
                  setIsViewFormVisible(false)
                  setSelectedViewId(null)
                }}
                onConfirm={handleView}
                title='View Contact'
                description='dsfsdff'
                data={selectedViewId?.description}
              />
            </>
          ) : (
            <img
              src={NoData}
              alt='No Data Available'
              className='w-200 h-200 mx-auto'
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Events
